/* global $, APP, AccessBellMeetJS, config, interfaceConfig */

import React from 'react';
import { Button, TextField } from '@material-ui/core';

import { AbstractWelcomePage, _mapStateToProps } from '../../../welcome/components/AbstractWelcomePage';

import { PasswordProtectedIcon } from '../../../base/icons/svg';

import { connect } from '../../../base/redux';
import { translate } from '../../../base/i18n';

import getRoomName from '../../../base/config/getRoomName';

class PasswordProtectedConference extends AbstractWelcomePage {

    constructor(props) {
        super(props);
        this.state = {
            password: "",
            room: getRoomName()
        }
    }

    _handlePasswordConfirmation() {
        if (this.state.password != "") {
            this._handleJoinMeeting()
        } else {
            alert("Please enter a password.");
        }
    }

    _handleJoinMeeting() {
        this._onJoinWithParams("&password=" + this.state.password);
    }

    render() {
        return (
            <div>
            <div className = "inlay" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div style={{display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: '200px'}}>
                    <PasswordProtectedIcon />
                </div>
                <h3 className = 'inlay__title' style={{marginTop: "125px"}}>
                    This conference is password protected.
                </h3>
                <TextField
                    id="meeting_password"
                    label="Meeting Password"
                    type="password"
                    value={this.state.password}
                    onChange={(event) => this.setState({password: event.target.value})}
                    autoComplete="current-password"
                    variant="filled"
                    style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%", borderRadius: 5, backgroundColor: "white"}}
                />
                <Button variant="contained" color="primary" onClick={this._handlePasswordConfirmation.bind(this)} style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%"}}>
                    Confirm Password
                </Button>
            </div>
            </div>
        )
    }
}

export default translate(connect(_mapStateToProps)(PasswordProtectedConference));